import { useState } from "react"

import { DisclosureChevron } from "@/components/terminal/disclosure-chevron"
import { Button } from "@/components/ui/button"
import type { TerminalPlatformRowModel } from "@/lib/terminal/company-file"

import { StarUnit } from "./star-unit"

// The Company's review profiles, folded under "N platforms monitored" in the
// Reviews box, as production showed them.
export const PlatformList = ({
  platforms,
}: {
  platforms: TerminalPlatformRowModel[]
}) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div>
      <Button
        type="button"
        variant="link"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        // Keep the disclosure-row look: normal weight and left layout over the
        // Button's bold, centered size box, with no link underline.
        className="type-row-label text-muted-foreground hover-bounded file-row -mx-2 h-auto items-center justify-start gap-1 bg-transparent px-2 font-normal tracking-normal normal-case hover:no-underline"
      >
        <DisclosureChevron isOpen={isOpen} />
        <span>
          {platforms.length} {platforms.length === 1 ? "platform" : "platforms"}{" "}
          monitored
        </span>
      </Button>
      {isOpen &&
        platforms.map((platform) => (
          <div
            key={platform.key}
            className="file-row-rule file-row items-center"
          >
            <a
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              title={platform.officialName}
              className="type-row-label text-terminal-accent min-w-0 flex-1 truncate no-underline hover:underline"
            >
              {platform.name}
            </a>
            {platform.reviewCount != null && (
              <span className="type-micro text-muted-foreground mr-3 font-normal tracking-normal normal-case tabular-nums">
                {platform.reviewCount.toLocaleString()} reviews
              </span>
            )}
            <span className="type-data text-foreground inline-flex items-center gap-1">
              {platform.rating == null ? "—" : platform.rating.toFixed(1)}
              {platform.rating != null && <StarUnit className="ml-0.5" />}
            </span>
          </div>
        ))}
    </div>
  )
}
